import React from 'react'
import './TabCard.css';

const TabCard = ({ icon }) => {
    return (
        <div className='tab-card-outer'>
            <img className='tab-card-img' src={icon} alt='tab-icons' />
        </div>
    )
}

export default TabCard